import { BetFailPlainError } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betFailPlainErrorDictionary = createSimpleDictionary([
    { id: BetFailPlainError.BookmakerFailedToExecute, name: 'dictionaries.betFailPlainError.bookmakerFailedToExecute' },
    { id: BetFailPlainError.OddsReduced, name: 'dictionaries.betFailPlainError.oddsReduced' },
    { id: BetFailPlainError.HandicapChanged, name: 'dictionaries.betFailPlainError.handicapChanged' },
    { id: BetFailPlainError.CreditLineError, name: 'dictionaries.betFailPlainError.creditLineError' },
    { id: BetFailPlainError.BookmakerError, name: 'dictionaries.betFailPlainError.bookmakerError' },
    { id: BetFailPlainError.InsufficientCredit, name: 'dictionaries.betFailPlainError.insufficientCredit' },
]);
